var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sensordaten"},[_vm._v("{{Sensordaten]}")])
}
var staticRenderFns = []

export { render, staticRenderFns }